import React from 'react';
import { ListBody } from '@pearsontechnology/aero-components';

import PlaceholderRow from './PlaceholderRow';

const PlaceholderList = () => (
  <ListBody>
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow />
    <PlaceholderRow />
  </ListBody>
);

export default PlaceholderList;
